import request from '@/lib/request'
import { productionSafeCriticalLogger } from '@/utils/logger'
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'

// Define a custom response type that includes both success and error cases
type ApiResponse<T> = AxiosResponse<T> | AxiosError

const ApiService = {
    async fetchData<Response = unknown, RequestData = unknown>(
        config: AxiosRequestConfig<RequestData>,
    ): Promise<ApiResponse<Response>> {
        try {
            const response = await request<Response, RequestData>(config)
            return response
        } catch (error) {
            // Use production-safe logging (only logs in development)
            productionSafeCriticalLogger.error('ApiService error:', {
                url: config.url,
                method: config.method,
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
            })

            return error as AxiosError
        }
    },
}

export default ApiService
